import { z } from 'zod';
import { RoleKeySchema } from './roles.js';
/**
 * Operator identity as resolved from a validated OIDC identity token.
 * Control accepts ONLY operator identities from its own configured issuer.
 * Tenant-HospaSense tokens (different issuer/audience) are rejected outright.
 */
export const OperatorIdentitySchema = z.object({
    /** `sub` claim from the identity provider. */
    subject: z.string().min(1),
    email: z.email(),
    displayName: z.string().min(1),
    /** True only when the token carried a phishing-resistant MFA/passkey assurance. */
    mfaVerified: z.boolean(),
    /** Time of the authentication event (auth_time), for step-up freshness checks. */
    authenticatedAt: z.iso.datetime(),
});
export const MeResponseSchema = z.object({
    userId: z.uuid(),
    email: z.email(),
    displayName: z.string(),
    roles: z.array(RoleKeySchema),
    /** Fully resolved permission list — the UI renders navigation from this. */
    permissions: z.array(z.string()),
    sessionExpiresAt: z.iso.datetime(),
});
/** Local synthetic sign-in (AUTH_MODE=synthetic only; disabled in production). */
export const SyntheticLoginRequestSchema = z
    .object({
    email: z.email(),
    /** Simulates the IdP's MFA assurance claim so deny-paths are testable. */
    mfa: z.boolean().default(true),
})
    .strict();
export const CsrfTokenResponseSchema = z.object({
    csrfToken: z.string(),
});
//# sourceMappingURL=auth.js.map